VjsAdmin.UserForm2 = (function () {
    const init = function () {
        checkRole();
        $('#user_license_ids').multiselect();
        $('#role_id').on('change', () => {
            checkRole();
        });
    };

    const checkRole = function () {
        const roleId = $('#role_id').val();

        if (+roleId === 2) {
            // student
            $('#grade').closest('.form-group').show();
        } else {
            $('#grade').closest('.form-group').hide();
        }

        if (+roleId === 2 || +roleId === 3 || +roleId === 4) {
            // students, teachers, school admin
            $('#user_license_ids').closest('.form-group').show();
        } else {
            $('#user_license_ids').closest('.form-group').hide();
        }
    };

    return {
        init,
    };
}());
